module.exports = __webpack_public_path__ + "img/icon_command_day.6344b347.svg";